import React, { useState } from 'react'
import { getMemberSince, getPosttype } from './AllDateTimeReleventFormate'
import CloudStorage from '../../CloudStorage/CloudStorage'
import { useNavigate } from 'react-router-dom';
import ProfileImageWithFallback from '../../common/ProfileImageWithFallback';

export default function CommonAbouttheClient({ posts }) {
    const laung = localStorage.getItem("laung");
    const [lan, setLan] = useState(laung ?? "en");
    const navigate = useNavigate();

    const navigatetodetailpage = () => {
        navigate(`/${lan}/expertsprofiledetails/${posts?.user?.id}`)
    }
    return (
        <div className='lang-sec'>
            <div onClick={() => { navigatetodetailpage() }} className="second-sec mt-3">
                <h6 className='activity-post '>About the Client </h6>
                <div className="d-flex" style={{ columnGap: '20px' }}>
                    <ProfileImageWithFallback url={posts?.user?.profile_image} style={{ width: '50px', height: '50px', borderRadius:'50%' }} alt="" />
                    <div className='d-flex flex-column' style={{ rowGap: '4px' }}>
                        <h4 className='m-0' style={{fontSize:'18px'}}>
                            {posts?.user?.first_name} {posts?.user?.last_name}
                        </h4>

                        <p>
                            <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/project/green-star.svg`}
                                alt=""
                            />&nbsp;&nbsp;
                            {posts?.user?.rating} ({posts?.user?.reviews} reviews)
                        </p>
                        <p>Member since {getMemberSince(posts?.user?.created_on)} </p>
                        <div className='d-flex' style={{ columnGap: '15px' }}>
                            <p style={{
                                minWidth: 'max-content',
                                justifyContent: 'unset',
                                maxWidth: '100%'
                            }}>
                                <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/project/verified.svg`}
                                    alt=""
                                />
                                &nbsp; Verified
                            </p>
                            <p>
                                <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                                    alt=""
                                />
                                &nbsp; Location: {posts?.user?.country}
                            </p>
                        </div>
                        <p></p>
                    </div>
                </div>
            </div>
        </div>
    )
}
